// A free product's own cover photo (3 Nov: "when a free product has a cover photo, it shows the photo"),
// on its Free resources card and its tile in the Library's Free resources strip. The photo sits in the
// private covers bucket and comes through a link sign-file signs for 2 minutes ({"covers": [product ids]},
// read with the member's own token, so row level security decides which come back), under the same rules
// as the webinar and recording thumbnails (free/thumbnails.js): asked only when 1 shown has a cover, kept
// 100 seconds, signed once more if it won't load. A product with no cover keeps its designed art, and so
// does 1 whose photo can't be had; while the link is on its way the space shows empty, so the designed art
// doesn't flash up first.
import { useThumbnails } from './thumbnails.js'

// items: the cards or tiles, each { id, coverPath }. cover(item) gives { url, pending }; failed and loaded
// are the <img>'s onError and onLoad, each with the item and the link.
export function useCovers(items) {
  const asThumbs = (items || []).map(i => ({ id: i.id, thumbnailPath: i.coverPath || null }))
  const { frame, failed, loaded } = useThumbnails(asThumbs, 'covers')
  const one = i => ({ id: i.id, thumbnailPath: i.coverPath || null })
  return {
    cover: i => frame(one(i)),
    failed: (i, src) => failed(one(i), src),
    loaded: (i, src) => loaded(one(i), src),
  }
}

// The photo for 1 item: an <img> when there's a link, nothing while it's on its way, and null when there's
// no cover (or none to be had), so the caller draws the designed art
export function coverState(covers, item) {
  if (!item.coverPath) return null
  const { url, pending } = covers.cover(item)
  if (url) return { url }
  if (pending) return { pending: true }
  return null
}
